/** Situações da Transportadora */
export interface TransportadoraSituacao {
    id: number;
    nome: string;
}

export const transportadoraAtiva: TransportadoraSituacao = {id: 1, nome: 'Ativa'};
export const transportadoraInativa: TransportadoraSituacao = {id: 2, nome: 'Inativa'};

export const TransportadoraSituacoes: TransportadoraSituacao[] = [
    transportadoraAtiva,
    transportadoraInativa
];

/** Verifica se o status da transportadora é igual a Ativa */
export function isTransportadoraAtiva(situacao: number): boolean {
    return situacao === transportadoraAtiva.id;
}

/** Verifica se o status da transportadora é igual a Inativa */
export function isTransportadoraInativa(situacao: number): boolean {
    return situacao === transportadoraInativa.id;
}
